export const CONTENT_MAX_HEIGHT = 'calc(100vh - 120px)' // 100vh - (Navbar + Breadcrumbs)
export const PAGE_NAV_WIDTH = 'w-[240px] 2xl:w-[309px]'
export const SIDENAV_COLLAPSED_WIDTH = 'w-8'
export const SIDENAV_EXPANDED_WIDTH = 'w-auto md:min-w-[240px] lg:w-[240px] 2xl:w-[309px]'
export const NAVBAR_TOP_SPACING = 'pt-[80px] lg:pt-[96px]'
export const WIKI_CONTENT_SPACING = 'lg:py-stack py-mobile-stack'
